import { defineStore } from 'pinia'

/**
 * Cross-cutting UI state.
 *
 * Mobile drawer, filter drawer, sidebar collapse, theme — anything
 * not owned by a specific page. Keep this store small; per-feature
 * UI state belongs in the feature's own store.
 */
export const useUIStore = defineStore('ui', {
  state: () => ({
    sidebarOpen: false,
    sidebarPinned: false,
    sidebarExpanded: false,
    filtersOpen: false,
    notifOpen: false,
    accountOpen: false,
    searchOpen: false,
  }),

  actions: {
    openSidebar() {
      this.sidebarOpen = true
    },
    closeDrawers() {
      this.sidebarOpen = false
      this.filtersOpen = false
    },
    openFilters() {
      this.filtersOpen = true
    },

    toggleSidebarExpanded() {
      this.sidebarExpanded = !this.sidebarExpanded
    },
    setSidebarExpanded(v) {
      this.sidebarExpanded = !!v
    },
    setSidebarPinned(v) {
      this.sidebarPinned = !!v
    },

    toggleNotif() {
      this.notifOpen = !this.notifOpen
      if (this.notifOpen) {
        this.accountOpen = false
      }
    },
    toggleAccount() {
      this.accountOpen = !this.accountOpen
      if (this.accountOpen) {
        this.notifOpen = false
      }
    },
    closePopups() {
      this.notifOpen = false
      this.accountOpen = false
    },

    openSearch() {
      this.searchOpen = true
    },
    closeSearch() {
      this.searchOpen = false
    },
    toggleSearch() {
      this.searchOpen = !this.searchOpen
    },
  },
})
